import { gql } from 'apollo-boost'

const MARK_MENU_SCRAPING_TASK_AS_AWAITING = gql`
  mutation markMenuScrapingTaskAsAwaiting(
    $id: ID!
    $awaitingReason: TaskAwaitingReason!
    $awaitingReasonComment: String
  ) {
    markMenuScrapingTaskAsAwaiting(
      id: $id
      awaitingReason: $awaitingReason
      awaitingReasonComment: $awaitingReasonComment
    ) {
      id
      awaitingReason
      awaitingReasonComment
      modifiedDate
    }
  }
`

export default MARK_MENU_SCRAPING_TASK_AS_AWAITING
